/**
 * Provides translations for the js / vue part of the app
 */
import Vue from 'vue';
import VueI18n from "vue-i18n";
import {LocaleManager as GridLocaleManager} from "@bryntum/grid";
import {LocaleManager as SchedulerLocaleManager} from "@bryntum/schedulerpro";

import '@bryntum/grid/locales/grid.locale.De';
import '@bryntum/schedulerpro/locales/schedulerpro.locale.De';

if(window.AshnetApp.currentLocale == "de"){
    GridLocaleManager.locale = 'De';
    SchedulerLocaleManager.locale = 'De';
}else{
    GridLocaleManager.locale = 'En';
    SchedulerLocaleManager.locale = 'En';
}




Vue.use(VueI18n);

const messages = {
    de: require('./locales/de-DE.json'),
    en: require('./locales/en-US.json'),
}

const i18n = new VueI18n({
    locale: window.AshnetApp.currentLocale,
    fallbackLocale: 'en',
    messages,
})

if(window.AshnetApp.currentLocale == "de"){
    if (process.env.NODE_ENV !== 'production') {
        //GridLocaleManager.throwOnMissingLocale = true;
        //SchedulerLocaleManager.throwOnMissingLocale = true;
    }

    //GridLocaleManager.locale = window.bryntum.locales.DeGrid;
    //SchedulerLocaleManager.locale = window.bryntum.locales.DeScheduler;
}else{
    //GridLocaleManager.locale = 'En';
    //SchedulerLocaleManager.locale = 'En';
}

export function $t(transKey){
    return i18n.tc(transKey);
}

export {i18n};
